import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTheme } from 'next-themes';
import { Moon, Sun, LayoutDashboard, Users, Truck, Wallet, FileCheck, Settings, LogOut, Upload, Calendar, AlertCircle, Briefcase, Wrench, Eye, Smartphone, CreditCard } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';

const nav = [
  { to: '/', icon: LayoutDashboard, label: 'Dashboard' },
  { to: '/drivers', icon: Users, label: 'Motoristas' },
  { to: '/vehicles', icon: Truck, label: 'Viaturas' },
  { to: '/finance', icon: Wallet, label: 'Financeiro' },
  { to: '/compliance', icon: FileCheck, label: 'Conformidade' },
  { to: '/audit', icon: Eye, label: 'Auditoria' },
  { to: '/weeks', icon: Calendar, label: 'Semanas' },
  { to: '/fines', icon: AlertCircle, label: 'Multas' },
  { to: '/partners', icon: Briefcase, label: 'Parceiros' },
  { to: '/service-orders', icon: Wrench, label: 'O.S.' },
  { to: '/auto-import', icon: Upload, label: 'Auto-Import' },
  { to: '/fiscal', icon: CreditCard, label: 'Fiscal' },
  { to: '/driver-app', icon: Smartphone, label: 'PWA' },
  { to: '/billing', icon: CreditCard, label: 'Faturação' },
];

export default function Sidebar({ onLogout }) {
  const location = useLocation();
  const { theme, setTheme } = useTheme();

  return (
    <aside className="hidden md:flex w-64 flex-col border-r bg-card h-screen sticky top-0 overflow-y-auto">
      <div className="p-6">
        <h1 className="text-xl font-bold tracking-tight text-primary">Fleet Twin OS</h1>
      </div>
      <nav className="flex-1 px-4 space-y-1 pb-4">
        {nav.map((item) => (
          <Link
            key={item.to}
            to={item.to}
            className={cn(
              'flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors',
              location.pathname === item.to || (item.to !== '/' && location.pathname.startsWith(item.to))
                ? 'bg-primary text-primary-foreground'
                : 'text-foreground hover:bg-muted'
            )}
          >
            <item.icon className="h-4 w-4" />
            {item.label}
          </Link>
        ))}
      </nav>
      <div className="p-4 border-t space-y-2">
        <Button variant="ghost" className="w-full justify-start gap-2" onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}>
          {theme === 'dark' ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
          Tema
        </Button>
        <Button variant="ghost" className="w-full justify-start gap-2 text-destructive" onClick={onLogout}>
          <LogOut className="h-4 w-4" />
          Sair
        </Button>
      </div>
    </aside>
  );
}
